import type { Presence } from 'src/types'
import dayjs from 'dayjs'

export const tot = (presences: Presence[], field: string = 'duration') => presences.reduce((tot, p) => tot + p[field], 0)
export const totPrice = (presences: Presence[], field: 'price' | 'panels' | 'tot' | 'employee_price' = 'price') => `€ ${currency(tot(presences, field))}`
export const totDuration = (presences: Presence[]) => toTime(tot(presences), false, true)
// le presenze levabolli (price !== null) non vengono conteggiate se il cantiere le esclude dal totale
export const totToInvoice = (presences: Presence[]) => tot(presences.filter(p => p.price !== null && !p.client?.exclude_levabolli_from_total), 'price') + tot(presences.filter(p => p.price === null), 'employee_price')

export const isOutOfThreshold = (p: Partial<Presence>, end = false) => {
  if (!p.client || !p.client.threshold) return null
  if (!end && p.distance === undefined) return null
  if (end && p.end_distance === undefined) return null
  return p[end ? 'end_distance' : 'distance']! > p.client.threshold
}

export const isSameEndPosition = (p: Presence) => {
  if (!p.end_position.lat || !p.end_position.lng) return null
  return p.position.lat === p.end_position.lat && p.position.lng === p.end_position.lng
}

export const validPosition = (position: google.maps.LatLngLiteral) => Object.values(position ?? {}).filter(Boolean).length
export const isOpen = (p: Partial<Presence>) => !p.end || p.pause === null
export const printTime = (p: Pick<Presence, 'start' | 'end' | 'pause' | 'duration'>, tooltip = false, startFormat = 'HH:mm') => {
  if (!hasTime(p)) return dayjs(p.start).format('ddd D MMM YYYY')
  let res = ''
  if (!p.end) res += `${tooltip ? 'START ' : ''}${dayjs(p.start).format(startFormat)}`
  else {
    res += `${dayjs(p.start).format(startFormat)} - ${dayjs(p.end).format('HH:mm')}`
    if (!tooltip && p.duration) res += `, ${toTime(p.duration, false)}`
    if (p.pause) res += ` ${toTime(p.pause)}`
  }
  return res
}
